import React from 'react'
import { AiOutlineInstagram, AiOutlineWhatsApp, AiOutlineYoutube, AiOutlineTwitter } from "react-icons/ai";



export const Contact = () => {
    return (
        <div className='contact' id='contact'>
            <div className="con-container">

                <h1>Have Questions? Reach Out to Us</h1>

                <input type='text' placeholder='Full Name' />
                <input type='text' placeholder='Email' />
                <input type='text' placeholder='Subject' />
                <input type='textbox' className='textbox' placeholder='Message' />
                <button className='msgsend'>Send</button>
            </div>


            <div className="con-content">
                <div className="icons">
                    <h2><AiOutlineInstagram /></h2>
                    <h2><AiOutlineWhatsApp /></h2>
                    <h2><AiOutlineYoutube /></h2>
                    <h2><AiOutlineTwitter /></h2>



                </div>
                <h1>TRAINR</h1>
                <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Magnam nobis incidunt numquam</p>

                <p>2/45 Tower Street, New York, USA</p>
                <p>0012 678 8899</p>
                <p>contact@trainr.com</p>
                <p>www.trainr.com</p>

                <p className='copy'>&copy; Copyright 2023 powered by MathanKumar</p>
            </div>
        </div>
    )
}
